import { cssClass } from '@/shared/utils'
import { skeleton } from './styles/index.css'

interface TextSkeletonProps {
  width?: string | number
  height?: string | number
  rounded?: string
}

export const TextSkeleton: React.FC<TextSkeletonProps> = ({
  width = '100%',
  height = '100%',
  rounded = 'rounded-24',
}) => {
  return (
    <div
      style={{
        width,
        height,
        maxWidth: '100%',
      }}
      className={cssClass([rounded, skeleton])}
    />
  )
}

export const LoadingText = (
  el: React.ReactNode,
  isLoading?: boolean,
  width?: string | number,
  height?: number
) => {
  if (isLoading) {
    return <TextSkeleton width={width ? width : '100%'} height={height || 18} />
  }

  return el
}
